import { isConcierge } from "../../users/accountRole"
import { isCallingPhoneReady } from "../utils"

/**
 * Outbound call prerequisites:
 * 1. Concierge → must have purchased calling number, then custom greeting
 * 2. Owner/team → must have Twilio call phone connected (no greeting rule)
 *
 * @returns {"ready" | "concierge_no_phone" | "concierge_no_greeting" | "owner_no_phone"}
 */
export function getOutboundCallGateState(crmSettings, profile) {
  if (isConcierge(profile)) {
    if (!profile?.twilio_voice_phone) {
      return "concierge_no_phone"
    }
    if (!profile?.has_greeting) {
      return "concierge_no_greeting"
    }
    return "ready"
  }

  if (!isCallingPhoneReady(crmSettings, profile)) {
    return "owner_no_phone"
  }

  return "ready"
}
